import { Linking } from 'react-native';

import { logger } from '@/utils/logging';

/**
 * Asynchronously attempts to open the phone dialer with the specified phone number.
 *
 * @param {string} phoneNumber - A phone number string that may contain hyphens (e.g., "1-XXX-XXX-XXXX" or "XXX-XXX-XXXX").
 * @returns {Promise<void>} Resolves when the operation is complete. If the URL scheme is unsupported or an error occurs, it logs the issue to the console.
 * @note If you're testing on a simulator (iOS) or emulator (Android), they might not support the `tel:` URL scheme.
 */
export const openDialerWithNumber = (phoneNumber: string) => {
    if (!phoneNumber?.trim()) {
        logger.warn('openDialerWithNumber called with empty phone number');
        return;
    }

    // Handle tel: prefix and leading + that the dialer doesn't need
    const parsedPhoneNumber = phoneNumber
        .replace(/^tel:/, '') // Remove tel: prefix if present
        .replace(/^\+/, '') // Remove leading + if present
        .replace(/-/g, ''); // Remove existing dash handling

    if (!parsedPhoneNumber.trim()) {
        logger.warn('Phone number became empty after parsing:', phoneNumber);
        return;
    }
    const url = `tel:${parsedPhoneNumber}`;

    try {
        Linking.openURL(url);
    } catch (err) {
        logger.error(`Unable to open dialer for the following phone number: ${phoneNumber}. With error: ${err}`);
    }
};
